module.exports = __webpack_public_path__ + "static/media/relacionamentos.eb610cd4.jpg";